/*
    Page bottom offset.
    Opposite of window.scrollY
*/
export const getPageBottomOffset = () => {
    return document.documentElement!.scrollHeight - (window.scrollY + window.innerHeight);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/directives/helpers.ts